/* eslint-disable no-return-assign */
import FormRow from './FormRow'
import PhoneInput from '../../forms/PhoneInput'
import { FormattedMessage, intlShape, injectIntl, defineMessages } from 'react-intl'

const msg = defineMessages({
  placeholderPhone: {
    id: 'placeholder.phone',
    defaultMessage: 'Enter phone number',
  },
})

function ContactPerson({ intl, errors, onChange, firstName, lastName, email, phone, setPhoneInstance, description, showTextArea }) {
  return <FormRow title={<FormattedMessage id='contact_person' defaultMessage='Contact person' />}>
    <div className='info-field'>
      <label className={`${errors.first_name ? 'error-field' : ''}`}>
        <strong>
          <FormattedMessage id='first_name' defaultMessage='First name' />
          <span className='asterisk'>*</span>
        </strong>
        <input type='text' required name='first_name' onChange={(e) => onChange('first_name', e.target.value)} value={firstName} />
        <div className='error-text'>
          <FormattedMessage id='required_field' defaultMessage='This field is required!' />
        </div>
      </label>
    </div>
    <div className='info-field'>
      <label className={`${errors.last_name ? 'error-field' : ''}`}>
        <strong>
          <FormattedMessage id='last_name' defaultMessage='Last name' />
          <span className='asterisk'>*</span>
        </strong>
        <input type='text' required name='last_name' onChange={(e) => onChange('last_name', e.target.value)} value={lastName} />
        <div className='error-text'>
          <FormattedMessage id='required_field' defaultMessage='This field is required!' />
        </div>
      </label>
    </div>
    <div className='info-field'>
      <label className={`${errors.email ? 'error-field' : ''}`}>
        <strong>
          <FormattedMessage id='email' defaultMessage='E-mail' />
          <span className='asterisk'>*</span>
        </strong>
        <input type='email' name='email' required onChange={(e) => onChange('email', e.target.value)} value={email} />
        <div className='error-text'>
          <FormattedMessage id='required_field' defaultMessage='This field is required!' />
        </div>
      </label>
    </div>
    <div className='info-field'>
      <label className={`${errors.phone ? 'error-field' : ''}`}>
        <strong>
          <FormattedMessage id='phone' defaultMessage='Phone number' />
          <span className='asterisk'>*</span>
        </strong>
        <PhoneInput
          placeholder={intl.formatMessage(msg.placeholderPhone)}
          value={phone}
          getPhoneInstance={setPhoneInstance}
          onChange={phone => onChange('phone', phone)} />
        <div className='error-text'>
          <FormattedMessage id='required_field' defaultMessage='This field is required!' />
        </div>
      </label>
    </div>
    { showTextArea ? (
      <div className='info-field'>
        <label>
          <strong>
            <FormattedMessage id='message' defaultMessage='Message' />
          </strong>
          <textarea
            className='textarea'
            value={description}
            onChange={(e) => onChange('description', e.target.value)} />
        </label>
      </div>
    ) : '' }
  </FormRow>
}

ContactPerson.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(ContactPerson)
